import { EditUserData } from "components/web-checkout/edit-userdata/edit-userdata";
import {
  ParentData,
  UserData
} from "components/web-checkout/edit-userdata/edit-userdata.types";
import { LoginBackground } from "components/web-checkout/login-background/login-background";
import { useUpdateUser } from "hooks/pages/use-update-user/use-update-user";
import { useRouter } from "next/router";
import { useToast } from "components/atoms/toast/toast-context";

const UpdateUserDetailsPage = () => {
  const router = useRouter();
  const { addToast } = useToast();
  const { userDetails, parentDetails } = useUpdateUser();

  const hasDataChanged = (
    newUserData: UserData,
    newParentData: ParentData
  ): boolean => {
    if (typeof window === "undefined") return false;

    const originalDataString = sessionStorage.getItem("originalUserFormData");
    if (!originalDataString) return false;

    try {
      const originalData = JSON.parse(originalDataString);

      if (originalData.userData) {
        const original = originalData.userData;
        if (
          newUserData.name !== original.name ||
          newUserData.email !== original.email ||
          newUserData.grade !== original.grade ||
          newUserData.curriculum !== original.curriculum ||
          newUserData.residence !== original.residence ||
          newUserData.schoolName !== original.schoolName
        ) {
          return true;
        }
      }

      if (originalData.parentData) {
        const original = originalData.parentData;
        if (
          newParentData.parentName !== original.parentName ||
          newParentData.parentPhone !== original.parentPhone
        ) {
          return true;
        }
      }

      return false;
    } catch (error) {
      console.error("Error parsing original data:", error);
      return false;
    }
  };

  const handleComplete = (userData: UserData, parentData: ParentData) => {
    const dataChanged = hasDataChanged(userData, parentData);
    if (typeof window !== "undefined") {
      sessionStorage.setItem(
        "updateUserFormData",
        JSON.stringify({
          userData,
          parentData,
          from: "update-user-details",
          hasChanges: dataChanged
        })
      );
    }

    if (dataChanged) {
      addToast({
        variant: "success",
        heading: "Data berhasil diubah",
        duration: 3000
      });
    }

    router.push("/user/register/user-details");
  };

  return (
    <LoginBackground routerPath={router.pathname}>
      <EditUserData
        userData={userDetails}
        parentData={parentDetails}
        onComplete={handleComplete}
      />
    </LoginBackground>
  );
};

UpdateUserDetailsPage.requireAuth = true;
export default UpdateUserDetailsPage;
